import { useEffect, useState } from 'react';
import { currentUserEmail, verifyPassword } from '../../lib/secureDelete';

/**
 * Modale de confirmation de suppression par mot de passe (parité A2).
 * Usage : afficher quand `open`, exécuter `onConfirm` seulement après re-auth réussie.
 */
interface ConfirmDeleteProps {
  open: boolean;
  label: string; // ce qui va être supprimé (ex. « l'option Sauce »)
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmDelete({ open, label, onCancel, onConfirm }: ConfirmDeleteProps) {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setPassword('');
      setError(null);
      currentUserEmail().then(setEmail);
    }
  }, [open]);

  if (!open) return null;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    const ok = await verifyPassword(email, password);
    setBusy(false);
    if (ok) {
      onConfirm();
    } else {
      setError('Mot de passe incorrect.');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <form onSubmit={submit} className="flex w-full max-w-sm flex-col gap-3 rounded-2xl bg-white p-5">
        <h3 className="text-lg font-bold text-red-600">Confirmer la suppression</h3>
        <p className="text-sm">
          Vous êtes sur le point de supprimer définitivement <strong>{label}</strong>. Entrez votre mot
          de passe pour confirmer.
        </p>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError(null);
          }}
          placeholder="Votre mot de passe"
          className="rounded-lg border border-slate-300 p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-400"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={busy}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-40"
          >
            {busy ? 'Vérification…' : 'Supprimer'}
          </button>
        </div>
      </form>
    </div>
  );
}
